import SettingPage from "./setting";

export default SettingPage;
